export enum TenderReferences {
  GiftCard = 'GC',
}
